
<p class="subtitle is-1">{{ ('organisation.form-management.title') | translate }}</p>

<hr>

  <div>
    <section class="section">
      <div>
        <div class="box no-margin full-width-box design-box">
          <div>
            <div class="columns px-5 is-flex is-align-items-center is-justify-content-space-between">

              <div class="column is-half">
                <input [formControl]="searchBar" class="input" type="text" placeholder="Search"/>
              </div>

              <div class="column">
              </div>

              <div class="column">
                <div class="is-flex is-justify-content-space-between is-justify-content-flex-end">
                  <button class="button export-csv-button" (click)="addStatePopupOpen()">
                    <img class="mr-2" src="assets/logos/organisation/download-icon.svg">
                    <span class="has-text-weight-semibold">{{ ('organisation.form-management.list.button.export-csv') | translate }}</span>
                  </button>

                  <button class="button add-contract-button" (click)="addStatePopupOpen()">
                    <i class="mr-2 fas fa-plus"></i>
                    <span class="has-text-weight-semibold">{{ ('organisation.form-management.list.button.add-form') | translate }}</span>
                  </button>

                </div>
              </div>
            </div>
          </div>

          <div class="table-container">
            <table class="table is-fullwidth custom-td custom-th">
              <thead>
                <tr class="has-background-white">

                  @for (column of tableColumnList; track column; let j = $index) {
                    <th class="px-1 py-3">
                      <table-header-button [buttonName]="'organisation.form-management.list.column.' + column.name" [buttonStatusLocal]="columnSortTracker[j]" (buttonStatus)="columnSortModification(j, $event, column.name)" ></table-header-button>
                    </th>
                  }
                  <th class="px-1 py-3 header-name is-size-6 has-text-weight-semibold">
                    {{ ('organisation.form-management.list.button.action') | translate }}
                  </th>
                </tr>
              </thead>

              <tbody>
                @for (team of displayList; track team; let i = $index) {
                  <tr class="has-background-white custom-tr">
                    @for (column of tableColumnList; track column) {
                      <td
                        class="px-1 py-2"
                        [ngClass]="column.class"
                        >
                        @switch (column.name) {
                          @default {
                            {{ getValueOfRowAttribute(team, column.name) }}
                          }
                        }
                      </td>
                    }
                    <td>
                      <div class="buttons is-flex is-align-items-center is-justify-content-space-between">
                        <button class="button edit-button" (click)="editStatePopupOpen(i)">
                          <span>{{ ('organisation.form-management.list.button.edit') | translate }}</span>
                        </button>
                        <button class="button edit-button" (click)="downloadFormFile(i)">
                          <span>{{ ('organisation.form-management.list.button.download') | translate }}</span>
                        </button>
                        <button class="button remove-button" (click)="removeStatePopupOpen(i)">
                          {{ ('organisation.form-management.list.button.delete') | translate }}
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>



  <add-form-popup [isModalVisible]="addStatePopup" (stateVisibleModal)="addStatePopupClose($event)" (newCreateForm)="addForm($event)"></add-form-popup>

  <remove-form-popup [isModalVisible]="removeStatePopup" [formObject]="deleteObject" (stateVisibleModal)="removeStatePopupClose($event)"></remove-form-popup>

  <edit-form-popup [isModalVisible]="editStatePopup" [uuidForm]="editUUID" (stateVisibleModal)="editStatePopupClose($event)" (updateForm)="editForm($event)"></edit-form-popup>
